export default "__VITE_ASSET__bbe3bcf4__"